import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import image1 from './images/milkshake/strawbery-shake.png'
import image2 from './images/milkshake/chocolate-shake.png'
import image3 from './images/milkshake/choco-hazelnut.png'
import image4 from './images/milkshake/blueberry-shake.png'
import image5 from './images/milkshake/mango-shake.png'
import image6 from './images/milkshake/bluebery-cheesecake.png'
import image7 from './images/milkshake/strawbery-oreo.png'
import image8 from './images/milkshake/mix-berry.png'
import image9 from './images/milkshake/choco-hazel-bomb.png'
import './menu.css'
import NavigationBar from './nav';
import NewNav from './canvas';

function Milkshakes() {
  const products=[
    { id:1, name:"Strawberry Shake", image: image1 },
    { id:2, name:"Chocolate Shake", image: image2 },
    { id:3, name:"Choco Hazelnut Shake", image: image3 },
    { id:4, name:"Blueberry Shake", image: image4 },
    { id:5, name:"Mango Shake", image: image5 },
    { id:6, name:"Blueberry Cheesecake Shake", image: image6 },
    { id:7, name:"Strawberry Oreo Shake", image: image7 },
    { id:8, name:"Mix Berry Shake", image: image8 },
    { id:9, name:"Choco Hazel bomb", image: image9 },
  ]
  return (
    <>
    <Container fluid>
              <Row>
              <NavigationBar/>
              <NewNav/>
                <Col id='rockTop'>  
                <Row>
                  <Col id='rockHeading'>
                  <p>Milkshakes</p>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Container>
      <Container>
        <Row>
          <Col md={12} style={{ height: "1100px",justifyContent:"center" }}>
            <Row>
              {products.map((p) => (
                <Col xs={6} md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center"}}>
                  <Card style={{border:"none"}}>
                    <Card.Img style={{height:"250px",border:"1px solid grey"}}
                      src={p.image} />
                    <Card.Body>
                      <Card.Title>
                        <span >
                          {p.name}
                        </span>
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Milkshakes